import { Adapter } from "@/core/models/adapter";
import { CircuitInstructionAdapter } from "@/core/models/circuitInstruction";

/**
 * Transport modes
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/xx/enums.json
 */
export const DEPOSIT_DROP = "drop";
export const DEPOSIT_POST = "post";
export const DEPOSIT_COLLECT = "collect";
export const DEPOSIT_DROP_LABEL = "drop_label";

export const DEPOSIT_TYPES = [DEPOSIT_DROP, DEPOSIT_POST, DEPOSIT_COLLECT, DEPOSIT_DROP_LABEL];

/**
 * Channels
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/xx/enums.json
 */
export const CHANNEL_WEB = "web";
export const CHANNEL_STORE = "store";

export const CHANNEL_TYPES = [CHANNEL_WEB, CHANNEL_STORE];

/**
 * Circuits
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/xx/enums.json
 */
export const CIRCUIT_WEB_DROP = "web_drop";
export const CIRCUIT_WEB_DROP_LABEL = "web_drop_label";
export const CIRCUIT_WEB_POST = "web_post";
export const CIRCUIT_WEB_COLLECT = "web_collect";
export const CIRCUIT_STORE_DROP = "store_drop";
// export const CIRCUIT_STORE_POST = "store_post"; // Non Utilisé
export const CIRCUIT_STORE_COLLECT = "store_collect";
export const CIRCUIT_STORE_DROP_LABEL = "store_drop_label";

export const CIRCUIT_TYPES = [
  CIRCUIT_WEB_DROP,
  CIRCUIT_WEB_DROP_LABEL,
  CIRCUIT_WEB_POST,
  CIRCUIT_WEB_COLLECT,
  CIRCUIT_STORE_DROP,
  // CIRCUIT_STORE_POST, // Non Utilisé
  CIRCUIT_STORE_COLLECT,
  CIRCUIT_STORE_DROP_LABEL,
];

/**
 * @param {string|null} deposit
 * @return {boolean}
 */
export const depositNeedsWarehouse = (deposit) => {
  return deposit === DEPOSIT_DROP_LABEL || deposit === DEPOSIT_DROP;
};

/**
 * @param {string|null} deposit
 * @return {boolean}
 */
export const depositNeedsTransport = (deposit) => {
  return deposit === DEPOSIT_POST || deposit === DEPOSIT_DROP_LABEL;
};

/**
 * Pour certains parcours Web, le parcours Store du même déposit doit être activé
 * @param {string|null} webDeposit
 * @return {boolean}
 */
export const webNeedStore = (webDeposit) => {
  return webDeposit === DEPOSIT_DROP || webDeposit === DEPOSIT_DROP_LABEL;
};

/**
 * @param {string|null} deposit
 * @return {boolean}
 */
export const depositIsPost = (deposit) => {
  return deposit === DEPOSIT_POST;
};

export const isStore = (channel) => {
  return channel === CHANNEL_STORE;
};

export class Circuit {
  constructor() {
    this.id = null;
    this.name = null;
    this.channel = null;
    this.deposit = null;
    this.transferOrderNumberOfCopy = null;
    this.defaultInstructions = [];
  }

  /**
   * @return {string}
   */
  getJsonLdId() {
    return `/circuits/${this.id}`;
  }

  /**
   * @return {boolean}
   */
  needsWarehouse() {
    return depositNeedsWarehouse(this.deposit);
  }

  needsTransport() {
    return depositNeedsTransport(this.deposit);
  }

  depositIsPost() {
    return depositIsPost(this.deposit);
  }

  isStore() {
    return isStore(this.channel);
  }

  /**
   * @return {boolean}
   */
  isWebToStore() {
    return this.channel === CHANNEL_WEB && (this.deposit === DEPOSIT_DROP || this.deposit === DEPOSIT_DROP_LABEL);
  }
}

export class CircuitAdapter extends Adapter {
  static adapt(circuitApi) {
    const circuit = new Circuit();
    circuit.id = circuitApi?.id;
    circuit.name = circuitApi?.name;
    circuit.channel = circuitApi?.channel;
    circuit.deposit = circuitApi?.deposit;
    circuit.transferOrderNumberOfCopy = circuitApi?.transferOrderNumberOfCopy;

    if (circuitApi?.defaultInstructions) {
      circuit.defaultInstructions = circuitApi.defaultInstructions.map((instructionApi) => {
        const circuitInstruction = CircuitInstructionAdapter.adapt(instructionApi);
        circuitInstruction.circuitId = circuit.id;
        return circuitInstruction;
      });
    }

    // Tri par séquence
    if (circuit?.defaultInstructions?.length) {
      circuit.defaultInstructions.sort((a, b) => a.sequence - b.sequence);
    }
    return circuit;
  }
}
